import { GeneralSetting } from '@apis/index'
import Column from '@components/column'
import HelmetSeo from '@components/HelmetSeo'
import { StyleColumn } from '@components/styles'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { BottomBanner, TopBanner } from './Banner'
import Books from './Books'
import GenreBooks from './genreBooks'
import { GenreBooksProvider } from './genreBooks/genreContext'
import Genres from './Genres'
import { HomePageWrapper, Title } from './style'

const HomePage = () => {
  const { data: homeSeo } = useSelector((state: any) => state.homeSeo)
  const fetchHomeSeo = async (state: string, key: string) => {
    await GeneralSetting.getByKey(state, key).catch(() => {})
  }
  const selectedGenre = useSelector((state: any) => state.selectedGenre)

  const [params, setParams] = useState({
    page: 1,
    limit: 10,
    category: selectedGenre || '',
  })
  const [initialValues, setInitialValues] = useState({
    metaTitle: '',
    metaDescription: '',
    metaKeyword: '',
  })

  useEffect(() => {
    if (!!homeSeo?.id) {
      const homeSeoValue = !!homeSeo?.value ? JSON.parse(homeSeo?.value) : null
      setInitialValues({
        metaTitle: homeSeoValue?.metaTitle,
        metaDescription: homeSeoValue?.metaDescription,
        metaKeyword: homeSeoValue?.metaKeyword,
      })
    }
  }, [homeSeo?.id])

  useEffect(() => {
    if (!homeSeo?.id) {
      fetchHomeSeo('homeSeo', 'homeSeo')
    }
  }, [])

  return (
    <HomePageWrapper>
      <HelmetSeo
        title={initialValues?.metaTitle}
        description={initialValues?.metaDescription}
        keywords={initialValues?.metaKeyword}
      />
      <StyleColumn
        customStyle={'gap: 12px; @media (max-width: 1024px) { gap: 0; }'}
      >
        <TopBanner />
        <StyleColumn
          customStyle={'gap: 8px; @media (max-width: 1024px) { gap: 4px; }'}
        >
          <Title>Genres</Title>
          <Genres params={params} setParams={setParams} />
        </StyleColumn>
        <Column
          styleColumn={
            'margin: 24px 0;@media (max-width: 1024px) { margin: 16px 0; }'
          }
        >
          <Books params={params} setParams={setParams} />
        </Column>

        <GenreBooksProvider>
          <GenreBooks />
        </GenreBooksProvider>

        <BottomBanner />
      </StyleColumn>
    </HomePageWrapper>
  )
}

export default HomePage
